import { useRef, useState } from 'react';

const useRefetchChoices = () => {
  const [triggerRefetch, setTriggerRefetch] = useState(0);
  const refetchResolveRef = useRef(null);

  const refetchChoices = () => {
    return new Promise(resolve => {
      refetchResolveRef.current = resolve;
      setTriggerRefetch(prev => prev + 1);
    });
  };

  const handleRefetchComplete = () => {
    if (refetchResolveRef.current) {
      refetchResolveRef.current();
      refetchResolveRef.current = null;
    }
  };

  return { triggerRefetch, refetchChoices, handleRefetchComplete };
};

export default useRefetchChoices;
